import React, { useEffect, useState } from 'react';
import MainLayout from 'components/MainLayout';
import { Card, Col, Input, Row, Typography } from 'antd';
import styled from 'styled-components';
import CustomButton from 'components/common/CustomButton';
import ManageEnrolledStudentTable from 'components/tables/ManageEnrolledStudentTable';
import { useQuery } from 'react-query';
import { manageStudent } from 'api/queries/Report';
import PageLoader from 'components/common/PageLoader';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { ArrowLeftOutlined } from '@ant-design/icons';
import AppData from 'AppData';

const ManageEnrolledStudent = () => {
  const { Text } = Typography;
  const [searchVal, setSearchVal] = useState('');
  const history = useHistory();
  const { manageenrolledstudent: courseId } = useParams();
  const location = useLocation();
  const [currentPage, setCurrentPage] = useState(1);
  const [startDate, setStartDate] = useState('');
  const [toggleExport, setToggleExport] = useState(false);
  const [endDate, setEndDate] = useState('');
  const [pageSize, setPageSize] = useState(10);
  const { isLoading, data: result, refetch: refetchReport } = useQuery(
    [
      'manageStudent',
      searchVal,
      courseId,
      toggleExport ? 1 : currentPage,
      toggleExport ? AppData.infinitePage : pageSize,
      startDate,
      endDate,
      toggleExport
    ],
    manageStudent
  );

  useEffect(() => {
    if (result && toggleExport && !isLoading) {
      base64Download(result?.file);
      setToggleExport(false);
    }
  }, [result, isLoading, toggleExport]);

  const base64Download = (base64Url, fileName = 'ManageEnrolledStudent.xlsx') => {
    const a = document.createElement('a');
    console.log('inside', base64Url);
    document.body.appendChild(a);
    a.href = `data:application/octet-stream;base64,${base64Url}`;
    a.download = fileName;
    a.click();
  };

  console.log(11, courseId);
  console.log(location?.state['record']);
  // console.log(endDate);

  const onSearch = value => setSearchVal(value);

  return (
    <MainLayout
      isAdmin
      sidebar
      padded
      selectedKey={location?.state['insightOverview'] ? 'insightOverview' : 'courseInsight'}>
      <Card>
        <HeaderRow gutter={16}>
          <Col span={8}>
            <Text>Manage Enrolled Student</Text>
            <HeaderWrapper>
              <Icon
                onClick={() => {
                  history.goBack();
                }}
              />
              <Title level={3}>{location?.state?.record?.courseName}</Title>
            </HeaderWrapper>
            <Text>{location?.state?.record?.institution}</Text>
          </Col>
          <CenterCol span={8}>
            <Search placeholder="Search Course, Student" onSearch={onSearch} size="large" />
          </CenterCol>
          <ExportCol span={8}>
            <CustomButton
              onClick={() => {
                setToggleExport(true);
              }}
              bgColor="#4d4d53"
              color="#fff"
              size="large">
              Export
            </CustomButton>
          </ExportCol>
        </HeaderRow>
        {result && (
          <ManageEnrolledStudentTable
            result={result}
            currentPage={currentPage}
            pageSize={pageSize}
            setCurrentPage={setCurrentPage}
            setPageSize={setPageSize}
            toggleExport={toggleExport}
          />
        )}
      </Card>
      <PageLoader fullWidth={isLoading} fullHeight={isLoading} isLoading={isLoading} />
    </MainLayout>
  );
};

const Title = styled(Typography.Title)`
  margin-bottom: 0px !important;
  color: #1890ff !important;
`;

const CenterCol = styled(Col)`
  display: flex;
  margin: auto;
`;

const ExportCol = styled(Col)`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
`;
const Icon = styled(ArrowLeftOutlined)`
  font-size: 20px;
  margin-right: 6px;
`;
const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const Search = styled(Input.Search)`
  width: 100%;
`;

const HeaderRow = styled(Row)`
  margin-bottom: 20px;
`;

export default ManageEnrolledStudent;
